module.exports = __webpack_public_path__ + "img/b_KalciyCS_left.0d8624d4.jpeg";